import { render, staticRenderFns } from "./PostcodeAddressAutocompleter.vue?vue&type=template&id=f319a77e&scoped=true"
import script from "./PostcodeAddressAutocompleter.vue?vue&type=script&lang=js"
export * from "./PostcodeAddressAutocompleter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f319a77e",
  null
  
)

export default component.exports